import React from "react";
import { Outlet } from "react-router-dom";

/**
 * Wrapper layout for tenant pages
 */
export const TenantLayout: React.FC = () => {
  return <Outlet />;
};
